/**
 * Canvas-level zoom (focus mode) actions carried by a {@link FlowDispatchEvent}.
 *
 * They are deliberately kept apart from `FlowActionPanelAction`, which carries the viewport and
 * edition intents of the action panel: these two target the *content* of the flow — the consumer
 * rebuilds the graph around a single node (`ZOOM_NODE`) or restores the full graph (`EXIT_ZOOM`).
 *
 * `EXIT_ZOOM` is a canvas-level action: it is emitted by the flow itself and carries **no** node.
 */
export enum FlowZoomAction {
  ZOOM_NODE = 'flow:zoom-node',
  EXIT_ZOOM = 'flow:exit-zoom'
}
